// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ftr-recovery-codes-modal__codes{
    display:grid;
    grid-template-columns:1fr 1fr 1fr;
    gap:0.5rem;
    padding:1rem;
    margin-bottom:1rem;
    background:#f6f7f8;
    border-radius:0.25rem;
  }

    @media (width > 640px){.ftr-recovery-codes-modal__codes{
      grid-template-columns:1fr 1fr 1fr 1fr 1fr
  }
    }

    .ftr-recovery-codes-modal__codes.codes-loading{
      display:flex;
      align-items:center;
      justify-content:center;
      padding:0;
    }
  .ftr-recovery-codes-modal__code{
    text-align:center;
  }
  .ftr-recovery-codes-modal__how-to{
    margin-bottom:1rem;
  }
  .ftr-recovery-codes-modal__how-to a{
      margin-left:0.5rem;
    }
  @media (width <= 640px){
  .ftr-recovery-codes-modal__how-to{
      display:none
  }
    }
  @media (width > 640px){
  .ftr-recovery-codes-modal__actions{
      display:flex;
      margin-bottom:2rem
  }
    }
  .ftr-recovery-codes-modal__action_button{
    margin-bottom:1rem;
  }
  @media (width > 640px){
  .ftr-recovery-codes-modal__action_button{
      flex:0 1 50%;
      margin-bottom:0
  }

      .ftr-recovery-codes-modal__action_button:first-child{
        margin-right:1rem;
      }
    }
  .ftr-recovery-codes-modal__action_button__text{
      margin-left:0.25rem;
      font-weight:bold;
    }
  @media (width > 640px){
  .ftr-recovery-codes-modal__close{
      display:flex
  }
    }
  .ftr-recovery-codes-modal__close__button{
      margin-bottom:1rem;
    }
  @media (width > 640px){
  .ftr-recovery-codes-modal__close__button{
        flex:0 1 auto;
        margin-right:1rem;
        margin-bottom:0
    }
      }
  @media (width > 640px){
  .ftr-recovery-codes-modal__close__confirm-text{
        flex:0 1 16.875rem;
        line-height:1.3rem;
    }
      }
  .ftr-recovery-codes-modal__close__confirm-text{
      color:#bf322e;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
